<template>
  <div class="row" style="margin-top:32px;">
    <div class="col s12">
      <div class="card" style="max-width:400px;margin:0 auto;">
        <div class="card-title primary white-text">
          <i class="material-icons icon">verified_user</i>
          Login
        </div>

        <form @submit.prevent="login">
          <div class="card-content">
            <div class="row" style="margin-bottom:0px;">
              <div class="input-field col s12">
                <input
                  type="text"
                  id="username"
                  autofocus
                  v-model="username"
                >
                <label for="username">Username</label>
                <span class="helper-text red-text">{{ (formErrors.username !== '') ? formErrors.username : '' }}</span>
              </div>

              <div class="input-field col s12">
                <input
                  type="password"
                  id="password"
                  v-model="password"
                >
                <label for="password">Password</label>
                <span class="helper-text red-text">{{ (formErrors.password !== '') ? formErrors.password : '' }}</span>
              </div>
            </div>

            <Loading
              :status="authStatus"
              :errorMessage="authError"
            />
          </div>

          <div class="card-action">
            <button
              type="submit"
              class="waves-effect waves-light btn"
              v-if="authStatus !== 'loading'"
            >Login</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
// Component to show loading animation during API call
import Loading from '@/components/lib/Loading'

// Import the API functions
import httpApi from '@/utils/api'

export default {
  // Name of this component
  name: 'Login',

  components: {
    Loading
  },

  props: ['k'],

  data () {
    return {
      // Automatically open login dialog on this page
      dialog: true,

      uniqueKey: '',

      // Variables to store form data
      username: '',
      password: '',

      // Remember state of password visibility
      passwordVisible: false,

      formErrors: {
        username: '',
        password: ''
      }
    }
  },

  mounted () {
    if (typeof this.k !== 'undefined') {
      this.uniqueKey = this.k

      httpApi.callWithKey({
        url: 'subscription/pending?k=' + this.uniqueKey,
        method: 'get'
      })
        .then((resp) => {
        })
        // If an error occurs
        .catch((err) => {
          this.validKey = false

          // Show error message
          this.$store.dispatch('SHOW_STATUS_MESSAGE', {
            color: 'error',
            message: err.message
          })
        })
    }
  },

  computed: {
    // Get vuex store data, to be used in this component
    ...mapGetters(['authStatus', 'authError', 'subscribe'])
  },

  methods: {
    // Login method
    login () {
      // Empty older errors
      this.formErrors = Object.assign({}, this.defaultFormErrors)

      let valid = true
      if (this.username === '') {
        this.formErrors.username = 'Cannot be empty'
        valid = false
      }
      if (this.password === '') {
        this.formErrors.password = 'Cannot be empty'
        valid = false
      }

      if (valid) {
        // Save form data to variables that we need to pass to API
        const user = this.username
        const pass = this.password
        let theKey = ''
        if (this.uniqueKey !== '') {
          theKey = this.uniqueKey
        }
        // Dispatch vuex store action, to call API login
        this.$store.dispatch('AUTH_REQUEST', { user, pass, theKey })
          .then((resp) => {
            // On successful login:
            if (parseInt(resp.data.validKey) === 1) {
              this.$router.push('/confirm-details/' + this.uniqueKey)
            } else {
              if (this.subscribe.planID > 0) {
                // If user is in the process of subscribing, take user to summary invoice page
                this.$router.push('/subscribe')
              } else {
                // Else, take user to list of subscriptions
                this.$router.push('/subscription')
              }
            }
          })
          .catch(() => {
            // Failure is handled by the store action
            // but eslint throws error if no catch() is defined
            // so here is an empty catch()
          })
      }
    }
  }
}
</script>
